import {axios} from "@/framework/utils/request";
import qs from "qs";        //npm install qs

const api_user = {
    /**
     * 登录校验
     * @param data:Object 传递的实体参数对象
     * @returns {AxiosPromise}
     */
    verifyLogin:function (data){
        return axios({
            url: "/login/verifyLogin",
            method: "post",
            data: qs.stringify(data)
        });
    },
    getUser:function (id){
        return axios({
            url:"/user/getUser",
            method:"get",
            params:{
                id:id
            }
        });
    },

    updateUser:function (data){
        return axios({
            url:"/user/updateUser",
            method:"post",
            data:qs.stringify(data)
        });
    },
    updateUserSelf:function (data){
        return axios({
            url:"/user/updateUserSelf",
            method:"post",
            data:qs.stringify(data)
        });
    },
    updateUserPwd:function (data){
        return axios({
            url:"/user/updateUserPwd",
            method:"post",
            data:qs.stringify(data)
        });
    },
    forceUpdateUserPwd:function (data){
        return axios({
            url:"/user/forceUpdateUserPwd",
            method:"post",
            data:qs.stringify(data)
        });
    },

    saveUser:function (data){
        return axios({
            url:"/user/saveUser",
            method:"post",
            data:qs.stringify(data)
        });
    },
    visitorAddToSys:function (uid){
        return axios({
            url:"/user/visitorAddToSys",
            method:"get",
            params:{
                uid:uid
            }
        });
    },
    setUserOffJob:function (uid){
        return axios({
            url:"/user/setUserOffJob",
            method:"get",
            params:{
                uid:uid
            }
        });
    },
    setUserOnJob:function (uid){
        return axios({
            url:"/user/setUserOnJob",
            method:"get",
            params:{
                uid:uid
            }
        });
    },
    countUserOffJob:function (){
        return axios({
            url:"/user/countUserOffJob",
            method:"get",
            params:{
            }
        });
    },
    removeToVisitor:function (uid){
        return axios({
            url:"/user/removeToVisitor",
            method:"get",
            params:{
                uid:uid
            }
        });
    },
    deleteUser:function (id){
        return axios({
            url:"/user/deleteUser",
            method:"get",
            params:{
                id:id
            }
        });
    },

    userManage:function (data){
        return axios({
            url:"/user/userManage",
            method:"post",
            data:qs.stringify(data)
        })
    },
    findAllVisitor:function (data){
        return axios({
            url:"/user/findAllVisitor",
            method:"post",
            data:qs.stringify(data)
        })
    },

    findAllReceiverUser:function (){
        return axios({
            url:"/user/findAllReceiverUser",
            method:"get",
            params:{
            }
        });
    },
    findAllUserOfTenant:()=>{
        return axios({
            url:"/user/findAllUserOfTenant",
            method:"get",
            params:{

            }
        });
    },
    heart:()=>{
        return axios({
            url:"/user/heart",
            method:"get",
            params:{
            }
        });
    },
    getUserLngLat:(uid)=>{
        return axios({
            url:"/user/getUserLngLat",
            method:"get",
            params:{
                uid:uid
            }
        });
    },
}

export default api_user;
